import styled from "styled-components";

export default styled.div`

& {
  width: 100%;
  height: 100%;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
  padding-left: 20px;
}
button{
  margin-top: 20px;
  margin-bottom: 20px;
}

.apartmentDetail{
  margin-left:20px;
}

main{
  display: flex;
  flex-direction:row;
  align-items: flex-start;
  height: auto;
  gap: ${props => props.theme.spacing.spacing_04};
}

.box{
  display: flex;
  flex-direction:row;
  align-items: flex-start;
  height: auto;
  gap: ${props => props.theme.spacing.spacing_04};
  div{
    margin-left: 5px;
    margin-right: 5px;
  }
}

.centered{
  text-align: center
}

/* 
form {
  margin-top: 15px;
  h1{
    font-size: 28px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 20px;
  }
  div{
    margin-top: 5px;
    margin-bottom: 5px;
    label {
      display:flex;
      align-items:center;
      height: 20px;
      width: 150px;
    }
    input, select, option {
      height: 30px;
      width: 200px;
      font-size: 16px;
    }
  }
} */

.blocks{
  margin-left: 20px;
}

.delete{
  margin-left:345px;
}



`